'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateLocation = exports.locationSelected = exports.joinWaitlist = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.doJoinWaitlist = doJoinWaitlist;
exports.doUpdateLocation = doUpdateLocation;
exports.openLocationModal = openLocationModal;
exports.getMsa = getMsa;
exports.watchLocationForm = watchLocationForm;
exports.watchWaitlistForm = watchWaitlistForm;

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _bound = require('redux/saga/entities/bound');

var _helpers = require('redux/saga/helpers');

var _msas = require('redux/saga/selectors/msas');

var _deep = require('helpers/deep');

var _homepage = require('redux/modules/features/homepage');

var _modals = require('redux/modules/modals');

var _multitrack = require('helpers/multitrack');

var _LeadGenForm = require('features/LeadGenForm/LeadGenForm.saga');

var _location = require('redux/saga/helpers/location');

var _locale = require('redux/modules/locale');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doJoinWaitlist),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(doUpdateLocation),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(openLocationModal),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(getMsa),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(watchLocationForm),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(watchWaitlistForm);

var LOCATION_SELECTED = 'classpass/LocationModal/LOCATION_SELECTED';
var JOIN_WAITLIST = 'classpass/LocationModal/JOIN_WAITLIST';
var UPDATE_LOCATION = 'classpass/LocationModal/UPDATE_LOCATION';

var joinWaitlist = exports.joinWaitlist = function joinWaitlist() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      email = _ref.email;

  return { type: JOIN_WAITLIST, email: email };
};
var locationSelected = exports.locationSelected = function locationSelected(msaId) {
  return { type: LOCATION_SELECTED, msaId: msaId };
};
var updateLocation = exports.updateLocation = function updateLocation(location) {
  return { type: UPDATE_LOCATION, location: location };
};

function doJoinWaitlist(client, _ref2) {
  var email = _ref2.email;
  var userLocation, lat, lon;
  return _regenerator2.default.wrap(function doJoinWaitlist$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.spawn)(_multitrack.ga, 'Geo_Detection_Modal', 'submit_email');

        case 2:
          _context.next = 4;
          return (0, _effects.select)(_locale.selectUserLocation);

        case 4:
          userLocation = _context.sent;

          if (!userLocation) {
            _context.next = 9;
            break;
          }

          lat = userLocation.lat, lon = userLocation.lon;
          _context.next = 9;
          return (0, _effects.call)(_LeadGenForm.doJoinWaitlist, client, { email: email, location: { lat: lat, lon: lon } });

        case 9:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function doUpdateLocation(client, _ref3) {
  var _ref3$location = _ref3.location,
      lat = _ref3$location.lat,
      lon = _ref3$location.lon;

  var _ref4, _ref5, _ref5$, location, _ref6, msaId, isPurchasable;

  return _regenerator2.default.wrap(function doUpdateLocation$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.spawn)(_multitrack.ga, 'Geo_Detection_Modal', 'submit_location');

        case 2:
          _context2.next = 4;
          return (0, _effects.all)([(0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.glsLocation, [client, lat, lon]), (0, _effects.call)(_location.persistUserLocation, lat, lon)]);

        case 4:
          _ref4 = _context2.sent;
          _ref5 = (0, _slicedToArray3.default)(_ref4, 1);
          _ref5$ = _ref5[0];
          location = _ref5$ === undefined ? {} : _ref5$;
          _ref6 = location.msa || {}, msaId = _ref6.id, isPurchasable = _ref6.package_purchase;

          if (!isPurchasable) {
            _context2.next = 14;
            break;
          }

          _context2.next = 12;
          return (0, _effects.put)(locationSelected(msaId));

        case 12:
          _context2.next = 14;
          return (0, _effects.put)((0, _homepage.setMsaId)(msaId));

        case 14:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function openLocationModal() {
  var modalProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref7, msaId;

  return _regenerator2.default.wrap(function openLocationModal$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)((0, _modals.showModal)('LocationModal', modalProps));

        case 2:
          if (!(__SERVER__ && !__TEST__)) {
            _context3.next = 4;
            break;
          }

          return _context3.abrupt('return', -1);

        case 4:
          _context3.next = 6;
          return (0, _effects.take)([_modals.HIDE_MODAL, locationSelected().type]);

        case 6:
          _ref7 = _context3.sent;
          msaId = _ref7.msaId;
          _context3.next = 10;
          return (0, _effects.put)((0, _modals.hideModal)('LocationModal'));

        case 10:
          return _context3.abrupt('return', msaId);

        case 11:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function getMsa(client) {
  var modalProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref8, _ref9, allMsas, msa, savedMsaId, msaId;

  return _regenerator2.default.wrap(function getMsa$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.all)([// eslint-disable-line prefer-const
          (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.msas, [client]), (0, _effects.call)(_helpers.geodetectMsa, client)]);

        case 3:
          _ref8 = _context4.sent;
          _ref9 = (0, _slicedToArray3.default)(_ref8, 2);
          allMsas = _ref9[0];
          msa = _ref9[1];
          _context4.next = 9;
          return (0, _effects.select)(_homepage.selectMsaId);

        case 9:
          savedMsaId = _context4.sent;

          if (!savedMsaId) {
            _context4.next = 12;
            break;
          }

          return _context4.abrupt('return', (0, _msas.msaByIdentifier)(allMsas, savedMsaId));

        case 12:
          if (!(0, _deep.deepExtract)('package_purchase', msa)) {
            _context4.next = 14;
            break;
          }

          return _context4.abrupt('return', msa);

        case 14:
          if (!(__SERVER__ && !__TEST__)) {
            _context4.next = 16;
            break;
          }

          return _context4.abrupt('return', -1);

        case 16:
          _context4.next = 18;
          return (0, _effects.call)(openLocationModal, modalProps);

        case 18:
          msaId = _context4.sent;

          msa = (0, _msas.msaByIdentifier)(allMsas, msaId);

          if (!(0, _deep.deepExtract)('package_purchase', msa)) {
            _context4.next = 25;
            break;
          }

          _context4.next = 23;
          return (0, _effects.put)((0, _homepage.setMsaId)(msa.id));

        case 23:
          _context4.next = 29;
          break;

        case 25:
          if (!((__CLIENT__ || __TEST__) && window.history.length > 2)) {
            _context4.next = 29;
            break;
          }

          _context4.next = 28;
          return (0, _effects.call)([window.history, window.history.back]);

        case 28:
          return _context4.abrupt('return', -1);

        case 29:
          return _context4.abrupt('return', msa);

        case 32:
          _context4.prev = 32;
          _context4.t0 = _context4['catch'](0);
          _context4.next = 36;
          return (0, _effects.put)((0, _helpers.errorActionCreator)('GET_MSA_ERROR', _context4.t0));

        case 36:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[0, 32]]);
}

function watchLocationForm(client) {
  return _regenerator2.default.wrap(function watchLocationForm$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, updateLocation().type, doUpdateLocation, client);

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function watchWaitlistForm(client) {
  return _regenerator2.default.wrap(function watchWaitlistForm$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, joinWaitlist().type, doJoinWaitlist, client);

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}